// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouterRouteImport } from './routes/app-router'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppBuilderRouteImport } from './routes/_app/_builder'
import { Route as AppAuthRouteImport } from './routes/_app/_auth'
import { Route as AppBuilderUserScoringRouteImport } from './routes/_app/_builder/user-scoring'
import { Route as AppBuilderSettingsRouteImport } from './routes/_app/_builder/settings'
import { Route as AppBuilderScreeningSearchRouteImport } from './routes/_app/_builder/screening-search'
import { Route as AppBuilderDetectionRouteImport } from './routes/_app/_builder/detection'
import { Route as AppBuilderDataRouteImport } from './routes/_app/_builder/data'
import { Route as AppBuilderContinuousScreeningRouteImport } from './routes/_app/_builder/continuous-screening'
import { Route as AppBuilderCasesRouteImport } from './routes/_app/_builder/cases'
import { Route as AppBuilderAnalyticsLegacyRouteImport } from './routes/_app/_builder/analytics-legacy'
import { Route as AppBuilderAccountRouteImport } from './routes/_app/_builder/account'
import { Route as AppAuthSignInEmailRouteImport } from './routes/_app/_auth/sign-in-email'
import { Route as AppAuthSignInRouteImport } from './routes/_app/_auth/sign-in'
import { Route as AppAuthEmailVerificationRouteImport } from './routes/_app/_auth/email-verification'
import { Route as AppAuthCreatePasswordRouteImport } from './routes/_app/_auth/create-password'
import { Route as AppAuthAuthRedirectRouteImport } from './routes/_app/_auth/auth-redirect'
import { Route as AppBuilderClientDetailIndexRouteImport } from './routes/_app/_builder/client-detail/index'
import { Route as AppBuilderUploadObjectTypeRouteImport } from './routes/_app/_builder/upload/$objectType'
import { Route as AppBuilderUserScoringIndexRouteImport } from './routes/_app/_builder/user-scoring/index'
import { Route as AppBuilderUserScoringOverviewRouteImport } from './routes/_app/_builder/user-scoring/overview'
import { Route as AppBuilderSettingsIndexRouteImport } from './routes/_app/_builder/settings/index'
import { Route as AppBuilderSettingsWebhooksRouteImport } from './routes/_app/_builder/settings/webhooks'
import { Route as AppBuilderSettingsUsersRouteImport } from './routes/_app/_builder/settings/users'
import { Route as AppBuilderSettingsTagsRouteImport } from './routes/_app/_builder/settings/tags'
import { Route as AppBuilderSettingsScreeningProvidersRouteImport } from './routes/_app/_builder/settings/screening-providers'
import { Route as AppBuilderSettingsScenariosRouteImport } from './routes/_app/_builder/settings/scenarios'
import { Route as AppBuilderSettingsIpWhitelistingRouteImport } from './routes/_app/_builder/settings/ip-whitelisting'
import { Route as AppBuilderSettingsInboxesRouteImport } from './routes/_app/_builder/settings/inboxes'
import { Route as AppBuilderSettingsAuditLogsRouteImport } from './routes/_app/_builder/settings/audit-logs'
import { Route as AppBuilderSettingsApiKeysRouteImport } from './routes/_app/_builder/settings/api-keys'
import { Route as AppBuilderSettingsAnalyticsRouteImport } from './routes/_app/_builder/settings/analytics'
import { Route as AppBuilderScreeningSearchIndexRouteImport } from './routes/_app/_builder/screening-search/index'
import { Route as AppBuilderDetectionIndexRouteImport } from './routes/_app/_builder/detection/index'
import { Route as AppBuilderDetectionScenariosRouteImport } from './routes/_app/_builder/detection/scenarios'
import { Route as AppBuilderDetectionListsRouteImport } from './routes/_app/_builder/detection/lists'
import { Route as AppBuilderDetectionDecisionsRouteImport } from './routes/_app/_builder/detection/decisions'
import { Route as AppBuilderDetectionAnalyticsRouteImport } from './routes/_app/_builder/detection/analytics'
import { Route as AppBuilderDataIndexRouteImport } from './routes/_app/_builder/data/index'
import { Route as AppBuilderDataListRouteImport } from './routes/_app/_builder/data/list'
import { Route as AppBuilderContinuousScreeningIndexRouteImport } from './routes/_app/_builder/continuous-screening/index'
import { Route as AppBuilderContinuousScreeningConfigurationsRouteImport } from './routes/_app/_builder/continuous-screening/configurations'
import { Route as AppBuilderCasesIndexRouteImport } from './routes/_app/_builder/cases/index'
import { Route as AppBuilderCasesOverviewRouteImport } from './routes/_app/_builder/cases/overview'
import { Route as AppBuilderCasesInboxesRouteImport } from './routes/_app/_builder/cases/inboxes'
import { Route as AppBuilderCasesAnalyticsRouteImport } from './routes/_app/_builder/cases/analytics'
import { Route as AppBuilderCasesDetailRouteImport } from './routes/_app/_builder/cases/_detail'
import { Route as AppBuilderCasesCaseIdRouteImport } from './routes/_app/_builder/cases/$caseId'
import { Route as AppBuilderClientDetailObjectTypeObjectIdRouteImport } from './routes/_app/_builder/client-detail/$objectType.$objectId'
import { Route as AppBuilderUserScoringRecordTypeVersionRouteImport } from './routes/_app/_builder/user-scoring/$recordType.$version'
import { Route as AppBuilderSettingsWebhooksWebhookIdRouteImport } from './routes/_app/_builder/settings/webhooks_.$webhookId'
import { Route as AppBuilderSettingsInboxesIndexRouteImport } from './routes/_app/_builder/settings/inboxes/index'
import { Route as AppBuilderSettingsInboxesInboxIdRouteImport } from './routes/_app/_builder/settings/inboxes/$inboxId'
import { Route as AppBuilderSettingsAnalyticsFiltersRouteImport } from './routes/_app/_builder/settings/analytics/filters'
import { Route as AppBuilderDetectionScenariosIndexRouteImport } from './routes/_app/_builder/detection/scenarios/index'
import { Route as AppBuilderDetectionScenariosScenarioIdRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId'
import { Route as AppBuilderDetectionListsIndexRouteImport } from './routes/_app/_builder/detection/lists/index'
import { Route as AppBuilderDetectionListsListIdRouteImport } from './routes/_app/_builder/detection/lists/$listId'
import { Route as AppBuilderDetectionDecisionsIndexRouteImport } from './routes/_app/_builder/detection/decisions/index'
import { Route as AppBuilderDetectionDecisionsDecisionIdRouteImport } from './routes/_app/_builder/detection/decisions/$decisionId'
import { Route as AppBuilderDetectionAnalyticsIndexRouteImport } from './routes/_app/_builder/detection/analytics/index'
import { Route as AppBuilderDetectionAnalyticsScenarioIdRouteImport } from './routes/_app/_builder/detection/analytics/$scenarioId'
import { Route as AppBuilderContinuousScreeningCreateIndexRouteImport } from './routes/_app/_builder/continuous-screening/create/index'
import { Route as AppBuilderCasesInboxesIndexRouteImport } from './routes/_app/_builder/cases/inboxes/index'
import { Route as AppBuilderCasesInboxesInboxIdRouteImport } from './routes/_app/_builder/cases/inboxes.$inboxId'
import { Route as AppBuilderCasesCaseIdIndexRouteImport } from './routes/_app/_builder/cases/$caseId/index'
import { Route as AppBuilderCasesCaseIdDRouteImport } from './routes/_app/_builder/cases/$caseId/d'
import { Route as AppBuilderDetectionScenariosScenarioIdIndexRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/index'
import { Route as AppBuilderDetectionScenariosScenarioIdWorkflowRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/workflow'
import { Route as AppBuilderDetectionScenariosScenarioIdTestRunRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/test-run'
import { Route as AppBuilderDetectionScenariosScenarioIdScheduledExecutionsRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/scheduled-executions'
import { Route as AppBuilderDetectionScenariosScenarioIdHomeRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/home'
import { Route as AppBuilderCasesDetailMCaseIdRouteImport } from './routes/_app/_builder/cases/_detail/m.$caseId'
import { Route as AppBuilderCasesCaseIdDDecisionIdRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId'
import { Route as AppBuilderDetectionScenariosScenarioIdTestRunIndexRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/test-run/index'
import { Route as AppBuilderCasesDetailSCaseIdOldRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/old'
import { Route as AppBuilderCasesDetailSCaseIdNewRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new'
import { Route as AppBuilderCasesCaseIdDDecisionIdScreeningsRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId/screenings'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId/_edit-view'
import { Route as AppBuilderDetectionScenariosScenarioIdTestRunTestRunIdIndexRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/test-run/$testRunId/index'
import { Route as AppBuilderCasesDetailSCaseIdNewIndexRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new/index'
import { Route as AppBuilderCasesDetailSCaseIdNewPrincipalRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new/principal'
import { Route as AppBuilderCasesDetailSCaseIdNewClientsRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new/clients'
import { Route as AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId/screenings/$screeningId'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewIndexRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId/_edit-view/index'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewTriggerRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId/_edit-view/trigger'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRulesRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId/_edit-view/rules'
import { Route as AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewDecisionRouteImport } from './routes/_app/_builder/detection/scenarios/$scenarioId/i/$iterationId/_edit-view/decision'
import { Route as AppBuilderCasesDetailSCaseIdNewClientsIndexRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new/clients/index'
import { Route as AppBuilderCasesDetailSCaseIdNewClientsPivotValueRouteImport } from './routes/_app/_builder/cases/_detail/s.$caseId/_new/clients/$pivotValue'
import { Route as AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdIndexRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId/screenings/$screeningId/index'
import { Route as AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdHitsRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId/screenings/$screeningId/hits'
import { Route as AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdFilesRouteImport } from './routes/_app/_builder/cases/$caseId/d/$decisionId/screenings/$screeningId/files'

const AppRouterRoute = AppRouterRouteImport.update({
            id: '/app-router',path: '/app-router',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AppBuilderRoute = AppBuilderRouteImport.update({
            id: '/_builder',getParentRoute: () => AppRoute
          })
const AppAuthRoute = AppAuthRouteImport.update({
            id: '/_auth',getParentRoute: () => AppRoute
          })
const AppBuilderUserScoringRoute = AppBuilderUserScoringRouteImport.update({
            id: '/user-scoring',path: '/user-scoring',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderSettingsRoute = AppBuilderSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderScreeningSearchRoute = AppBuilderScreeningSearchRouteImport.update({
            id: '/screening-search',path: '/screening-search',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderDetectionRoute = AppBuilderDetectionRouteImport.update({
            id: '/detection',path: '/detection',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderDataRoute = AppBuilderDataRouteImport.update({
            id: '/data',path: '/data',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderContinuousScreeningRoute = AppBuilderContinuousScreeningRouteImport.update({
            id: '/continuous-screening',path: '/continuous-screening',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderCasesRoute = AppBuilderCasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderAnalyticsLegacyRoute = AppBuilderAnalyticsLegacyRouteImport.update({
            id: '/analytics-legacy',path: '/analytics-legacy',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderAccountRoute = AppBuilderAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppBuilderRoute
          })
const AppAuthSignInEmailRoute = AppAuthSignInEmailRouteImport.update({
            id: '/sign-in-email',path: '/sign-in-email',getParentRoute: () => AppAuthRoute
          })
const AppAuthSignInRoute = AppAuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AppAuthRoute
          })
const AppAuthEmailVerificationRoute = AppAuthEmailVerificationRouteImport.update({
            id: '/email-verification',path: '/email-verification',getParentRoute: () => AppAuthRoute
          })
const AppAuthCreatePasswordRoute = AppAuthCreatePasswordRouteImport.update({
            id: '/create-password',path: '/create-password',getParentRoute: () => AppAuthRoute
          })
const AppAuthAuthRedirectRoute = AppAuthAuthRedirectRouteImport.update({
            id: '/auth-redirect',path: '/auth-redirect',getParentRoute: () => AppAuthRoute
          })
const AppBuilderClientDetailIndexRoute = AppBuilderClientDetailIndexRouteImport.update({
            id: '/client-detail/',path: '/client-detail/',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderUploadObjectTypeRoute = AppBuilderUploadObjectTypeRouteImport.update({
            id: '/upload/$objectType',path: '/upload/$objectType',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderUserScoringIndexRoute = AppBuilderUserScoringIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderUserScoringRoute
          })
const AppBuilderUserScoringOverviewRoute = AppBuilderUserScoringOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AppBuilderUserScoringRoute
          })
const AppBuilderSettingsIndexRoute = AppBuilderSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsWebhooksRoute = AppBuilderSettingsWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsUsersRoute = AppBuilderSettingsUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsTagsRoute = AppBuilderSettingsTagsRouteImport.update({
            id: '/tags',path: '/tags',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsScreeningProvidersRoute = AppBuilderSettingsScreeningProvidersRouteImport.update({
            id: '/screening-providers',path: '/screening-providers',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsScenariosRoute = AppBuilderSettingsScenariosRouteImport.update({
            id: '/scenarios',path: '/scenarios',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsIpWhitelistingRoute = AppBuilderSettingsIpWhitelistingRouteImport.update({
            id: '/ip-whitelisting',path: '/ip-whitelisting',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsInboxesRoute = AppBuilderSettingsInboxesRouteImport.update({
            id: '/inboxes',path: '/inboxes',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsAuditLogsRoute = AppBuilderSettingsAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsApiKeysRoute = AppBuilderSettingsApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsAnalyticsRoute = AppBuilderSettingsAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderScreeningSearchIndexRoute = AppBuilderScreeningSearchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderScreeningSearchRoute
          })
const AppBuilderDetectionIndexRoute = AppBuilderDetectionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionRoute
          })
const AppBuilderDetectionScenariosRoute = AppBuilderDetectionScenariosRouteImport.update({
            id: '/scenarios',path: '/scenarios',getParentRoute: () => AppBuilderDetectionRoute
          })
const AppBuilderDetectionListsRoute = AppBuilderDetectionListsRouteImport.update({
            id: '/lists',path: '/lists',getParentRoute: () => AppBuilderDetectionRoute
          })
const AppBuilderDetectionDecisionsRoute = AppBuilderDetectionDecisionsRouteImport.update({
            id: '/decisions',path: '/decisions',getParentRoute: () => AppBuilderDetectionRoute
          })
const AppBuilderDetectionAnalyticsRoute = AppBuilderDetectionAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AppBuilderDetectionRoute
          })
const AppBuilderDataIndexRoute = AppBuilderDataIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDataRoute
          })
const AppBuilderDataListRoute = AppBuilderDataListRouteImport.update({
            id: '/list',path: '/list',getParentRoute: () => AppBuilderDataRoute
          })
const AppBuilderContinuousScreeningIndexRoute = AppBuilderContinuousScreeningIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderContinuousScreeningRoute
          })
const AppBuilderContinuousScreeningConfigurationsRoute = AppBuilderContinuousScreeningConfigurationsRouteImport.update({
            id: '/configurations',path: '/configurations',getParentRoute: () => AppBuilderContinuousScreeningRoute
          })
const AppBuilderCasesIndexRoute = AppBuilderCasesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderCasesOverviewRoute = AppBuilderCasesOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderCasesInboxesRoute = AppBuilderCasesInboxesRouteImport.update({
            id: '/inboxes',path: '/inboxes',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderCasesAnalyticsRoute = AppBuilderCasesAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderCasesDetailRoute = AppBuilderCasesDetailRouteImport.update({
            id: '/_detail',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderCasesCaseIdRoute = AppBuilderCasesCaseIdRouteImport.update({
            id: '/$caseId',path: '/$caseId',getParentRoute: () => AppBuilderCasesRoute
          })
const AppBuilderClientDetailObjectTypeObjectIdRoute = AppBuilderClientDetailObjectTypeObjectIdRouteImport.update({
            id: '/client-detail/$objectType/$objectId',path: '/client-detail/$objectType/$objectId',getParentRoute: () => AppBuilderRoute
          })
const AppBuilderUserScoringRecordTypeVersionRoute = AppBuilderUserScoringRecordTypeVersionRouteImport.update({
            id: '/$recordType/$version',path: '/$recordType/$version',getParentRoute: () => AppBuilderUserScoringRoute
          })
const AppBuilderSettingsWebhooksWebhookIdRoute = AppBuilderSettingsWebhooksWebhookIdRouteImport.update({
            id: '/webhooks_/$webhookId',path: '/webhooks/$webhookId',getParentRoute: () => AppBuilderSettingsRoute
          })
const AppBuilderSettingsInboxesIndexRoute = AppBuilderSettingsInboxesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderSettingsInboxesRoute
          })
const AppBuilderSettingsInboxesInboxIdRoute = AppBuilderSettingsInboxesInboxIdRouteImport.update({
            id: '/$inboxId',path: '/$inboxId',getParentRoute: () => AppBuilderSettingsInboxesRoute
          })
const AppBuilderSettingsAnalyticsFiltersRoute = AppBuilderSettingsAnalyticsFiltersRouteImport.update({
            id: '/filters',path: '/filters',getParentRoute: () => AppBuilderSettingsAnalyticsRoute
          })
const AppBuilderDetectionScenariosIndexRoute = AppBuilderDetectionScenariosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionScenariosRoute
          })
const AppBuilderDetectionScenariosScenarioIdRoute = AppBuilderDetectionScenariosScenarioIdRouteImport.update({
            id: '/$scenarioId',path: '/$scenarioId',getParentRoute: () => AppBuilderDetectionScenariosRoute
          })
const AppBuilderDetectionListsIndexRoute = AppBuilderDetectionListsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionListsRoute
          })
const AppBuilderDetectionListsListIdRoute = AppBuilderDetectionListsListIdRouteImport.update({
            id: '/$listId',path: '/$listId',getParentRoute: () => AppBuilderDetectionListsRoute
          })
const AppBuilderDetectionDecisionsIndexRoute = AppBuilderDetectionDecisionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionDecisionsRoute
          })
const AppBuilderDetectionDecisionsDecisionIdRoute = AppBuilderDetectionDecisionsDecisionIdRouteImport.update({
            id: '/$decisionId',path: '/$decisionId',getParentRoute: () => AppBuilderDetectionDecisionsRoute
          })
const AppBuilderDetectionAnalyticsIndexRoute = AppBuilderDetectionAnalyticsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionAnalyticsRoute
          })
const AppBuilderDetectionAnalyticsScenarioIdRoute = AppBuilderDetectionAnalyticsScenarioIdRouteImport.update({
            id: '/$scenarioId',path: '/$scenarioId',getParentRoute: () => AppBuilderDetectionAnalyticsRoute
          })
const AppBuilderContinuousScreeningCreateIndexRoute = AppBuilderContinuousScreeningCreateIndexRouteImport.update({
            id: '/create/',path: '/create/',getParentRoute: () => AppBuilderContinuousScreeningRoute
          })
const AppBuilderCasesInboxesIndexRoute = AppBuilderCasesInboxesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesInboxesRoute
          })
const AppBuilderCasesInboxesInboxIdRoute = AppBuilderCasesInboxesInboxIdRouteImport.update({
            id: '/$inboxId',path: '/$inboxId',getParentRoute: () => AppBuilderCasesInboxesRoute
          })
const AppBuilderCasesCaseIdIndexRoute = AppBuilderCasesCaseIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesCaseIdRoute
          })
const AppBuilderCasesCaseIdDRoute = AppBuilderCasesCaseIdDRouteImport.update({
            id: '/d',path: '/d',getParentRoute: () => AppBuilderCasesCaseIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdIndexRoute = AppBuilderDetectionScenariosScenarioIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdWorkflowRoute = AppBuilderDetectionScenariosScenarioIdWorkflowRouteImport.update({
            id: '/workflow',path: '/workflow',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdTestRunRoute = AppBuilderDetectionScenariosScenarioIdTestRunRouteImport.update({
            id: '/test-run',path: '/test-run',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdScheduledExecutionsRoute = AppBuilderDetectionScenariosScenarioIdScheduledExecutionsRouteImport.update({
            id: '/scheduled-executions',path: '/scheduled-executions',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdHomeRoute = AppBuilderDetectionScenariosScenarioIdHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderCasesDetailMCaseIdRoute = AppBuilderCasesDetailMCaseIdRouteImport.update({
            id: '/m/$caseId',path: '/m/$caseId',getParentRoute: () => AppBuilderCasesDetailRoute
          })
const AppBuilderCasesCaseIdDDecisionIdRoute = AppBuilderCasesCaseIdDDecisionIdRouteImport.update({
            id: '/$decisionId',path: '/$decisionId',getParentRoute: () => AppBuilderCasesCaseIdDRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdRouteImport.update({
            id: '/i/$iterationId',path: '/i/$iterationId',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdTestRunIndexRoute = AppBuilderDetectionScenariosScenarioIdTestRunIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdTestRunRoute
          })
const AppBuilderCasesDetailSCaseIdOldRoute = AppBuilderCasesDetailSCaseIdOldRouteImport.update({
            id: '/s/$caseId/old',path: '/s/$caseId/old',getParentRoute: () => AppBuilderCasesDetailRoute
          })
const AppBuilderCasesDetailSCaseIdNewRoute = AppBuilderCasesDetailSCaseIdNewRouteImport.update({
            id: '/s/$caseId/_new',path: '/s/$caseId',getParentRoute: () => AppBuilderCasesDetailRoute
          })
const AppBuilderCasesCaseIdDDecisionIdScreeningsRoute = AppBuilderCasesCaseIdDDecisionIdScreeningsRouteImport.update({
            id: '/screenings',path: '/screenings',getParentRoute: () => AppBuilderCasesCaseIdDDecisionIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteImport.update({
            id: '/_edit-view',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdIIterationIdRoute
          })
const AppBuilderDetectionScenariosScenarioIdTestRunTestRunIdIndexRoute = AppBuilderDetectionScenariosScenarioIdTestRunTestRunIdIndexRouteImport.update({
            id: '/$testRunId/',path: '/$testRunId/',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdTestRunRoute
          })
const AppBuilderCasesDetailSCaseIdNewIndexRoute = AppBuilderCasesDetailSCaseIdNewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesDetailSCaseIdNewRoute
          })
const AppBuilderCasesDetailSCaseIdNewPrincipalRoute = AppBuilderCasesDetailSCaseIdNewPrincipalRouteImport.update({
            id: '/principal',path: '/principal',getParentRoute: () => AppBuilderCasesDetailSCaseIdNewRoute
          })
const AppBuilderCasesDetailSCaseIdNewClientsRoute = AppBuilderCasesDetailSCaseIdNewClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AppBuilderCasesDetailSCaseIdNewRoute
          })
const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute = AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteImport.update({
            id: '/$screeningId',path: '/$screeningId',getParentRoute: () => AppBuilderCasesCaseIdDDecisionIdScreeningsRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewIndexRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewTriggerRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewTriggerRouteImport.update({
            id: '/trigger',path: '/trigger',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRulesRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRulesRouteImport.update({
            id: '/rules',path: '/rules',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute
          })
const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewDecisionRoute = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewDecisionRouteImport.update({
            id: '/decision',path: '/decision',getParentRoute: () => AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute
          })
const AppBuilderCasesDetailSCaseIdNewClientsIndexRoute = AppBuilderCasesDetailSCaseIdNewClientsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesDetailSCaseIdNewClientsRoute
          })
const AppBuilderCasesDetailSCaseIdNewClientsPivotValueRoute = AppBuilderCasesDetailSCaseIdNewClientsPivotValueRouteImport.update({
            id: '/$pivotValue',path: '/$pivotValue',getParentRoute: () => AppBuilderCasesDetailSCaseIdNewClientsRoute
          })
const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdIndexRoute = AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute
          })
const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdHitsRoute = AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdHitsRouteImport.update({
            id: '/hits',path: '/hits',getParentRoute: () => AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute
          })
const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdFilesRoute = AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute
          })





const AppAuthRouteChildren = {
  AppAuthAuthRedirectRoute: AppAuthAuthRedirectRoute,AppAuthCreatePasswordRoute: AppAuthCreatePasswordRoute,AppAuthEmailVerificationRoute: AppAuthEmailVerificationRoute,AppAuthSignInRoute: AppAuthSignInRoute,AppAuthSignInEmailRoute: AppAuthSignInEmailRoute
}

const AppAuthRouteWithChildren = AppAuthRoute._addFileChildren(AppAuthRouteChildren)




const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteChildren = {
  AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdFilesRoute: AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdFilesRoute,AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdHitsRoute: AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdHitsRoute,AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdIndexRoute: AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdIndexRoute
}

const AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteWithChildren = AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute._addFileChildren(AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteChildren)



const AppBuilderCasesCaseIdDDecisionIdScreeningsRouteChildren = {
  AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRoute: AppBuilderCasesCaseIdDDecisionIdScreeningsScreeningIdRouteWithChildren
}

const AppBuilderCasesCaseIdDDecisionIdScreeningsRouteWithChildren = AppBuilderCasesCaseIdDDecisionIdScreeningsRoute._addFileChildren(AppBuilderCasesCaseIdDDecisionIdScreeningsRouteChildren)



const AppBuilderCasesCaseIdDDecisionIdRouteChildren = {
  AppBuilderCasesCaseIdDDecisionIdScreeningsRoute: AppBuilderCasesCaseIdDDecisionIdScreeningsRouteWithChildren
}

const AppBuilderCasesCaseIdDDecisionIdRouteWithChildren = AppBuilderCasesCaseIdDDecisionIdRoute._addFileChildren(AppBuilderCasesCaseIdDDecisionIdRouteChildren)



const AppBuilderCasesCaseIdDRouteChildren = {
  AppBuilderCasesCaseIdDDecisionIdRoute: AppBuilderCasesCaseIdDDecisionIdRouteWithChildren
}

const AppBuilderCasesCaseIdDRouteWithChildren = AppBuilderCasesCaseIdDRoute._addFileChildren(AppBuilderCasesCaseIdDRouteChildren)



const AppBuilderCasesCaseIdRouteChildren = {
  AppBuilderCasesCaseIdDRoute: AppBuilderCasesCaseIdDRouteWithChildren,AppBuilderCasesCaseIdIndexRoute: AppBuilderCasesCaseIdIndexRoute
}

const AppBuilderCasesCaseIdRouteWithChildren = AppBuilderCasesCaseIdRoute._addFileChildren(AppBuilderCasesCaseIdRouteChildren)




const AppBuilderCasesDetailSCaseIdNewClientsRouteChildren = {
  AppBuilderCasesDetailSCaseIdNewClientsPivotValueRoute: AppBuilderCasesDetailSCaseIdNewClientsPivotValueRoute,AppBuilderCasesDetailSCaseIdNewClientsIndexRoute: AppBuilderCasesDetailSCaseIdNewClientsIndexRoute
}

const AppBuilderCasesDetailSCaseIdNewClientsRouteWithChildren = AppBuilderCasesDetailSCaseIdNewClientsRoute._addFileChildren(AppBuilderCasesDetailSCaseIdNewClientsRouteChildren)



const AppBuilderCasesDetailSCaseIdNewRouteChildren = {
  AppBuilderCasesDetailSCaseIdNewClientsRoute: AppBuilderCasesDetailSCaseIdNewClientsRouteWithChildren,AppBuilderCasesDetailSCaseIdNewPrincipalRoute: AppBuilderCasesDetailSCaseIdNewPrincipalRoute,AppBuilderCasesDetailSCaseIdNewIndexRoute: AppBuilderCasesDetailSCaseIdNewIndexRoute
}

const AppBuilderCasesDetailSCaseIdNewRouteWithChildren = AppBuilderCasesDetailSCaseIdNewRoute._addFileChildren(AppBuilderCasesDetailSCaseIdNewRouteChildren)



const AppBuilderCasesDetailRouteChildren = {
  AppBuilderCasesDetailMCaseIdRoute: AppBuilderCasesDetailMCaseIdRoute,AppBuilderCasesDetailSCaseIdNewRoute: AppBuilderCasesDetailSCaseIdNewRouteWithChildren,AppBuilderCasesDetailSCaseIdOldRoute: AppBuilderCasesDetailSCaseIdOldRoute
}

const AppBuilderCasesDetailRouteWithChildren = AppBuilderCasesDetailRoute._addFileChildren(AppBuilderCasesDetailRouteChildren)




const AppBuilderCasesInboxesRouteChildren = {
  AppBuilderCasesInboxesInboxIdRoute: AppBuilderCasesInboxesInboxIdRoute,AppBuilderCasesInboxesIndexRoute: AppBuilderCasesInboxesIndexRoute
}

const AppBuilderCasesInboxesRouteWithChildren = AppBuilderCasesInboxesRoute._addFileChildren(AppBuilderCasesInboxesRouteChildren)



const AppBuilderCasesRouteChildren = {
  AppBuilderCasesCaseIdRoute: AppBuilderCasesCaseIdRouteWithChildren,AppBuilderCasesDetailRoute: AppBuilderCasesDetailRouteWithChildren,AppBuilderCasesAnalyticsRoute: AppBuilderCasesAnalyticsRoute,AppBuilderCasesInboxesRoute: AppBuilderCasesInboxesRouteWithChildren,AppBuilderCasesOverviewRoute: AppBuilderCasesOverviewRoute,AppBuilderCasesIndexRoute: AppBuilderCasesIndexRoute
}

const AppBuilderCasesRouteWithChildren = AppBuilderCasesRoute._addFileChildren(AppBuilderCasesRouteChildren)




const AppBuilderContinuousScreeningRouteChildren = {
  AppBuilderContinuousScreeningConfigurationsRoute: AppBuilderContinuousScreeningConfigurationsRoute,AppBuilderContinuousScreeningIndexRoute: AppBuilderContinuousScreeningIndexRoute,AppBuilderContinuousScreeningCreateIndexRoute: AppBuilderContinuousScreeningCreateIndexRoute
}

const AppBuilderContinuousScreeningRouteWithChildren = AppBuilderContinuousScreeningRoute._addFileChildren(AppBuilderContinuousScreeningRouteChildren)




const AppBuilderDataRouteChildren = {
  AppBuilderDataListRoute: AppBuilderDataListRoute,AppBuilderDataIndexRoute: AppBuilderDataIndexRoute
}

const AppBuilderDataRouteWithChildren = AppBuilderDataRoute._addFileChildren(AppBuilderDataRouteChildren)




const AppBuilderDetectionAnalyticsRouteChildren = {
  AppBuilderDetectionAnalyticsScenarioIdRoute: AppBuilderDetectionAnalyticsScenarioIdRoute,AppBuilderDetectionAnalyticsIndexRoute: AppBuilderDetectionAnalyticsIndexRoute
}

const AppBuilderDetectionAnalyticsRouteWithChildren = AppBuilderDetectionAnalyticsRoute._addFileChildren(AppBuilderDetectionAnalyticsRouteChildren)




const AppBuilderDetectionDecisionsRouteChildren = {
  AppBuilderDetectionDecisionsDecisionIdRoute: AppBuilderDetectionDecisionsDecisionIdRoute,AppBuilderDetectionDecisionsIndexRoute: AppBuilderDetectionDecisionsIndexRoute
}

const AppBuilderDetectionDecisionsRouteWithChildren = AppBuilderDetectionDecisionsRoute._addFileChildren(AppBuilderDetectionDecisionsRouteChildren)




const AppBuilderDetectionListsRouteChildren = {
  AppBuilderDetectionListsListIdRoute: AppBuilderDetectionListsListIdRoute,AppBuilderDetectionListsIndexRoute: AppBuilderDetectionListsIndexRoute
}

const AppBuilderDetectionListsRouteWithChildren = AppBuilderDetectionListsRoute._addFileChildren(AppBuilderDetectionListsRouteChildren)




const AppBuilderDetectionScenariosScenarioIdTestRunRouteChildren = {
  AppBuilderDetectionScenariosScenarioIdTestRunIndexRoute: AppBuilderDetectionScenariosScenarioIdTestRunIndexRoute,AppBuilderDetectionScenariosScenarioIdTestRunTestRunIdIndexRoute: AppBuilderDetectionScenariosScenarioIdTestRunTestRunIdIndexRoute
}

const AppBuilderDetectionScenariosScenarioIdTestRunRouteWithChildren = AppBuilderDetectionScenariosScenarioIdTestRunRoute._addFileChildren(AppBuilderDetectionScenariosScenarioIdTestRunRouteChildren)




const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteChildren = {
  AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewDecisionRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewDecisionRoute,AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRulesRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRulesRoute,AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewTriggerRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewTriggerRoute,AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewIndexRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewIndexRoute
}

const AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteWithChildren = AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute._addFileChildren(AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteChildren)



const AppBuilderDetectionScenariosScenarioIdIIterationIdRouteChildren = {
  AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdEditViewRouteWithChildren
}

const AppBuilderDetectionScenariosScenarioIdIIterationIdRouteWithChildren = AppBuilderDetectionScenariosScenarioIdIIterationIdRoute._addFileChildren(AppBuilderDetectionScenariosScenarioIdIIterationIdRouteChildren)



const AppBuilderDetectionScenariosScenarioIdRouteChildren = {
  AppBuilderDetectionScenariosScenarioIdHomeRoute: AppBuilderDetectionScenariosScenarioIdHomeRoute,AppBuilderDetectionScenariosScenarioIdScheduledExecutionsRoute: AppBuilderDetectionScenariosScenarioIdScheduledExecutionsRoute,AppBuilderDetectionScenariosScenarioIdTestRunRoute: AppBuilderDetectionScenariosScenarioIdTestRunRouteWithChildren,AppBuilderDetectionScenariosScenarioIdWorkflowRoute: AppBuilderDetectionScenariosScenarioIdWorkflowRoute,AppBuilderDetectionScenariosScenarioIdIndexRoute: AppBuilderDetectionScenariosScenarioIdIndexRoute,AppBuilderDetectionScenariosScenarioIdIIterationIdRoute: AppBuilderDetectionScenariosScenarioIdIIterationIdRouteWithChildren
}

const AppBuilderDetectionScenariosScenarioIdRouteWithChildren = AppBuilderDetectionScenariosScenarioIdRoute._addFileChildren(AppBuilderDetectionScenariosScenarioIdRouteChildren)



const AppBuilderDetectionScenariosRouteChildren = {
  AppBuilderDetectionScenariosScenarioIdRoute: AppBuilderDetectionScenariosScenarioIdRouteWithChildren,AppBuilderDetectionScenariosIndexRoute: AppBuilderDetectionScenariosIndexRoute
}

const AppBuilderDetectionScenariosRouteWithChildren = AppBuilderDetectionScenariosRoute._addFileChildren(AppBuilderDetectionScenariosRouteChildren)



const AppBuilderDetectionRouteChildren = {
  AppBuilderDetectionAnalyticsRoute: AppBuilderDetectionAnalyticsRouteWithChildren,AppBuilderDetectionDecisionsRoute: AppBuilderDetectionDecisionsRouteWithChildren,AppBuilderDetectionListsRoute: AppBuilderDetectionListsRouteWithChildren,AppBuilderDetectionScenariosRoute: AppBuilderDetectionScenariosRouteWithChildren,AppBuilderDetectionIndexRoute: AppBuilderDetectionIndexRoute
}

const AppBuilderDetectionRouteWithChildren = AppBuilderDetectionRoute._addFileChildren(AppBuilderDetectionRouteChildren)




const AppBuilderScreeningSearchRouteChildren = {
  AppBuilderScreeningSearchIndexRoute: AppBuilderScreeningSearchIndexRoute
}

const AppBuilderScreeningSearchRouteWithChildren = AppBuilderScreeningSearchRoute._addFileChildren(AppBuilderScreeningSearchRouteChildren)




const AppBuilderSettingsAnalyticsRouteChildren = {
  AppBuilderSettingsAnalyticsFiltersRoute: AppBuilderSettingsAnalyticsFiltersRoute
}

const AppBuilderSettingsAnalyticsRouteWithChildren = AppBuilderSettingsAnalyticsRoute._addFileChildren(AppBuilderSettingsAnalyticsRouteChildren)




const AppBuilderSettingsInboxesRouteChildren = {
  AppBuilderSettingsInboxesInboxIdRoute: AppBuilderSettingsInboxesInboxIdRoute,AppBuilderSettingsInboxesIndexRoute: AppBuilderSettingsInboxesIndexRoute
}

const AppBuilderSettingsInboxesRouteWithChildren = AppBuilderSettingsInboxesRoute._addFileChildren(AppBuilderSettingsInboxesRouteChildren)



const AppBuilderSettingsRouteChildren = {
  AppBuilderSettingsAnalyticsRoute: AppBuilderSettingsAnalyticsRouteWithChildren,AppBuilderSettingsApiKeysRoute: AppBuilderSettingsApiKeysRoute,AppBuilderSettingsAuditLogsRoute: AppBuilderSettingsAuditLogsRoute,AppBuilderSettingsInboxesRoute: AppBuilderSettingsInboxesRouteWithChildren,AppBuilderSettingsIpWhitelistingRoute: AppBuilderSettingsIpWhitelistingRoute,AppBuilderSettingsScenariosRoute: AppBuilderSettingsScenariosRoute,AppBuilderSettingsScreeningProvidersRoute: AppBuilderSettingsScreeningProvidersRoute,AppBuilderSettingsTagsRoute: AppBuilderSettingsTagsRoute,AppBuilderSettingsUsersRoute: AppBuilderSettingsUsersRoute,AppBuilderSettingsWebhooksRoute: AppBuilderSettingsWebhooksRoute,AppBuilderSettingsIndexRoute: AppBuilderSettingsIndexRoute,AppBuilderSettingsWebhooksWebhookIdRoute: AppBuilderSettingsWebhooksWebhookIdRoute
}

const AppBuilderSettingsRouteWithChildren = AppBuilderSettingsRoute._addFileChildren(AppBuilderSettingsRouteChildren)




const AppBuilderUserScoringRouteChildren = {
  AppBuilderUserScoringOverviewRoute: AppBuilderUserScoringOverviewRoute,AppBuilderUserScoringIndexRoute: AppBuilderUserScoringIndexRoute,AppBuilderUserScoringRecordTypeVersionRoute: AppBuilderUserScoringRecordTypeVersionRoute
}

const AppBuilderUserScoringRouteWithChildren = AppBuilderUserScoringRoute._addFileChildren(AppBuilderUserScoringRouteChildren)



const AppBuilderRouteChildren = {
  AppBuilderAccountRoute: AppBuilderAccountRoute,AppBuilderAnalyticsLegacyRoute: AppBuilderAnalyticsLegacyRoute,AppBuilderCasesRoute: AppBuilderCasesRouteWithChildren,AppBuilderContinuousScreeningRoute: AppBuilderContinuousScreeningRouteWithChildren,AppBuilderDataRoute: AppBuilderDataRouteWithChildren,AppBuilderDetectionRoute: AppBuilderDetectionRouteWithChildren,AppBuilderScreeningSearchRoute: AppBuilderScreeningSearchRouteWithChildren,AppBuilderSettingsRoute: AppBuilderSettingsRouteWithChildren,AppBuilderUserScoringRoute: AppBuilderUserScoringRouteWithChildren,AppBuilderUploadObjectTypeRoute: AppBuilderUploadObjectTypeRoute,AppBuilderClientDetailIndexRoute: AppBuilderClientDetailIndexRoute,AppBuilderClientDetailObjectTypeObjectIdRoute: AppBuilderClientDetailObjectTypeObjectIdRoute
}

const AppBuilderRouteWithChildren = AppBuilderRoute._addFileChildren(AppBuilderRouteChildren)



const AppRouteChildren = {
  AppAuthRoute: AppAuthRouteWithChildren,AppBuilderRoute: AppBuilderRouteWithChildren
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  SplatRoute: SplatRoute,AppRoute: AppRouteWithChildren,AppRouterRoute: AppRouterRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)